import { useState } from 'react';

import { useUpdateEffect } from './useUpdateEffect';
import { DateType, objectNowDate, objectYesterdayDate, validateSearchPeriod } from '../../utils/dateHandler';

/**
 * 検索期間の状態管理用カスタムフック
 */
export const useStateSearchPeriod = () => {
	// 検索条件で使用するデータの管理
	const [startDate, setStartDate] = useState<DateType | null>(objectYesterdayDate()); // 開始日の管理
	const [endDate, setEndDate] = useState<DateType | null>(objectNowDate()); // 終了日の管理

	// アラートの管理
	const [isInputDateError, setIsInputDateError] = useState(false); // 検索期間設定エラーの状態管理
	const [isAlertOpened, setIsAlertOpened] = useState(false); // アラートの表示の状態管理

	// 検索期間の有効範囲のチェック
	useUpdateEffect(() => {
		const isSuccess = validateSearchPeriod(startDate, endDate);

		if (!isSuccess) {
			setIsInputDateError(true);
			setIsAlertOpened(true);
			return;
		}

		setIsInputDateError(false);
		setIsAlertOpened(false);
	}, [startDate, endDate]);

	// 開始日を変更した際の処理
	const handleChangeStartDate = (newValue: DateType | null) => {
		setStartDate(newValue);
	};

	// 終了日を変更した際の処理
	const handleChangeEndDate = (newValue: DateType | null) => {
		setEndDate(newValue);
	};

	// 検索期間設定エラーのアラートを閉じる際の処理

	const onCloseInputDateErrorAlert = () => {
		setIsAlertOpened(false);
	};

	return {
		startDate,
		endDate,
		isInputDateError,
		isAlertOpened,
		handleChangeStartDate,
		handleChangeEndDate,
		onCloseInputDateErrorAlert,
	};
};
